import React from "react";
import { EditorBlock } from "draft-js";
export default class TableBlock extends React.Component {
  render() {
    let data = this.props.block.getData().toJS() || {};
    let table = data.table || [];
    const preview = this.props.blockProps && this.props.blockProps.tableResizePreview;
    const previewForThisTable = preview && preview.rootKey === data.key ? preview : null;
    let classes = [];
    for (let k in data) {
      classes.push(`editor-block-data-${k}-${data[k]}`);
    }

    return (
      <div className="editor-table-block">
        <table className="w-100">
          <tbody>
            {table.map((row, index) => {
              const displayRowHeight = previewForThisTable
                ? previewForThisTable.rowHeights[index]
                : row[0] && row[0].rowHeight;
              const rowGuideIndex =
                previewForThisTable && previewForThisTable.guideAxis === "row"
                  ? previewForThisTable.guideIndex
                  : null;
              return (
                <tr
                  key={`${data.key}${index}`}
                  style={
                    displayRowHeight
                      ? { height: `${displayRowHeight}px` }
                      : undefined
                  }
                >
                  {row.map((col, colIndex) => {
                    if (col.hidden) return null;
                    const colSpan = col.colSpan || 1;
                    const rowSpan = col.rowSpan || 1;
                    const displayWidth = previewForThisTable
                      ? previewForThisTable.widths
                          .slice(colIndex, colIndex + colSpan)
                          .reduce((sum, width) => sum + Number(width || 0), 0)
                      : col.width;
                    const isColumnGuide =
                      previewForThisTable &&
                      previewForThisTable.guideAxis === "column" &&
                      previewForThisTable.guideIndex === colIndex + colSpan - 1;
                    return (
                      <td
                        className={` 
                               editor-table-cell
                            ${
                              data.align &&
                              col.self &&
                              `editor-block-align-${data.align}`
                            }                  
                            ${
                              col.borderLeft
                                ? "editor-table-cell-border-left"
                                : ""
                            }
                            ${
                              col.borderRight
                                ? "editor-table-cell-border-right"
                                : ""
                            } 
                            ${
                              col.borderTop
                                ? "editor-table-cell-border-top"
                                : ""
                            }
                            ${
                              col.borderBottom
                                ? "editor-table-cell-border-bottom"
                                : ""
                            }
                            ${
                              col.padding
                                ? `editor-table-cell-padding-${col.padding}`
                                : ""
                            }
                             
                        `}
                        key={`${data.key}${col.key}`}
                        id={`editor-table-cell-${col.key}`}
                        data-table-column-start={colIndex}
                        data-table-column-end={colIndex + colSpan - 1}
                        data-table-row-start={index}
                        data-table-row-end={index + rowSpan - 1}
                        onMouseDown={(event) => {
                          const bounds = event.currentTarget.getBoundingClientRect();
                          const nearBottom = bounds.bottom - event.clientY <= 10;
                          const nearRight = bounds.right - event.clientX <= 10;
                          if (
                            (nearBottom || nearRight) &&
                            this.props.blockProps &&
                            this.props.blockProps.onTableResizeStart
                          ) {
                            this.props.blockProps.onTableResizeStart(
                              event,
                              nearBottom ? "row" : "column",
                              col.key
                            );
                            return;
                          }
                          if (
                            this.props.blockProps &&
                            this.props.blockProps.onTableCellMouseDown
                          ) {
                            this.props.blockProps.onTableCellMouseDown(
                              event,
                              col.key
                            );
                          }
                        }}
                        onMouseOver={(event) => {
                          if (
                            this.props.blockProps &&
                            this.props.blockProps.onTableCellMouseEnter
                          ) {
                            this.props.blockProps.onTableCellMouseEnter(
                              event,
                              col.key
                            );
                          }
                        }}
                        onDoubleClick={(event) => {
                          const bounds = event.currentTarget.getBoundingClientRect();
                          const nearBottom = bounds.bottom - event.clientY <= 10;
                          const nearRight = bounds.right - event.clientX <= 10;
                          if (
                            (nearBottom || nearRight) &&
                            this.props.blockProps &&
                            this.props.blockProps.onTableAutoFit
                          ) {
                            event.preventDefault();
                            event.stopPropagation();
                            this.props.blockProps.onTableAutoFit(
                              nearBottom ? "row" : "column",
                              col.key
                            );
                          }
                        }}
                        onContextMenu={
                          this.props.blockProps &&
                          this.props.blockProps.onTableContextMenu
                            ? (event) => {
                            this.props.blockProps.onTableContextMenu(
                              event,
                              col.key
                            );
                              }
                            : undefined
                        }
                        style={{
                          backgroundColor: col.backgroundColor,
                          width: displayWidth && `${displayWidth}%`,
                          height: displayRowHeight && `${displayRowHeight}px`,
                          verticalAlign: col.verticalAlign,
                          borderRight: isColumnGuide
                            ? "2px dashed #3699ff"
                            : undefined,
                          borderBottom:
                            rowGuideIndex === index + rowSpan - 1
                              ? "2px dashed #3699ff"
                              : undefined,
                        }}
                        colSpan={colSpan}
                        rowSpan={rowSpan}
                      >
                        {col.self && (
                          <div className={`editor-block ${classes.join(" ")}`}>
                            <EditorBlock
                              className={classes.join(" ")}
                              {...this.props}
                            />
                          </div>
                        )}
                        {this.props.blockProps &&
                          this.props.blockProps.onTableResizeStart && (
                            <>
                              <span
                                className="table-resize-handle table-resize-handle-column"
                                title="Перетащите, чтобы изменить ширину; двойной щелчок — подобрать по тексту"
                                onMouseDown={(event) =>
                                  this.props.blockProps.onTableResizeStart(
                                    event,
                                    "column",
                                    col.key
                                  )
                                }
                              />
                              <span
                                className="table-resize-handle table-resize-handle-row"
                                title="Перетащите, чтобы изменить высоту; двойной щелчок — подобрать по тексту"
                                onMouseDown={(event) =>
                                  this.props.blockProps.onTableResizeStart(
                                    event,
                                    "row",
                                    col.key
                                  )
                                }
                              />
                            </>
                          )}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}
